import React, { useEffect, useState } from "react";
import "./AudienceMetrics.scss";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import AudienceByAge from "../AudienceByAge/AudienceByAge";
import AudienceByGender from "../AudienceByGender/AudienceByGender";
import AudienceByCountry from "../AudienceByCountry/AudienceByCountry";
import AudienceByCity from "../AudienceByCity/AudienceByCity";
import { Icon } from "semantic-ui-react";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import InstagramPageSelector from "../InstagramPageSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";

function AudienceMetrics(props) {
    const [isNoData, setIsNoDataState] = useState(false);
    const chart = React.useRef(null);
    useEffect(() => {
        if (props.isIGPage) {
            props.changeGraphType("pie");
        }
    }, []);

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const capitalize = (s) => {
        let words = s.split(" ");
        let text = "";
        words.forEach((ele, ind) => {
            let lowerCaseText = ele.trim();
            text += lowerCaseText[0].toUpperCase() + lowerCaseText.slice(1) + " ";
        });
        return text;
    };
    const downLoadCSV = () => {
        let chartName = props.widget?.name || "Audience Metrics";
        let chartData = props.data;
        let downLoadingData = [];
        if (props.activeTab === 0) {
            let currentChartData = chartData["audience_metrics_by_age"].barChartData;
            downLoadingData.push(["Age Range", "Count"]);
            let count = 0;
            currentChartData.forEach((ele, ind) => {
                count += ele.data[0].y;
                downLoadingData.push([ele.data[0].name, ele.data[0].y]);
            });
            downLoadingData.push(["Total", count]);
        }
        if (props.activeTab === 1) {
            let currentChartData = chartData["audience_metrics_by_gender"].barChartData;
            downLoadingData.push(["Gender", "Count"]);
            let count = 0;
            currentChartData.forEach((ele, ind) => {
                count += ele.data[0].y;
                downLoadingData.push([ele.data[0].name, ele.data[0].y]);
            });
            downLoadingData.push(["Total", count]);
        }
        if (props.activeTab === 2) {
            let currentChartData = chartData["audience_metrics_by_country"].barChartData;
            let chartDownloadData = chartData["audience_metrics_by_country"].downLoadData;
            let allLocation = chartData["audience_metrics_by_country"].allLocation;
            downLoadingData.push(["Country", "Count"]);
            let count = 0;
            chartDownloadData.forEach((ele, ind) => {
                count += ele.count;
                downLoadingData.push([allLocation[ele.name], ele.count]);
            });
            downLoadingData.push(["Total", count]);
        }
        if (props.activeTab === 3) {
            let currentChartData = chartData["audience_metrics_by_city"].barChartData;
            let chartDownloadData = chartData["audience_metrics_by_city"].downLoadData;
            downLoadingData.push(["City", "Count"]);
            let count = 0;
            chartDownloadData.forEach((ele, ind) => {
                count += ele.count;
                downLoadingData.push([capitalize(ele.name), ele.count]);
            });
            downLoadingData.push(["Total", count]);
        }
        downloadCSVData(downLoadingData, chartName);
    };
    const downLoadPNG = (cb) => {
        let chartName = props.widget?.name || "Audience Metrics";
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, chartName);
                },
            );
    };
    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={props.widget?.name || "Audience Metrics"}
                    info="This is an aggregated demographic data based on age, gender, country and city distribution that user provided in their instagram profile. Does not include current day's data."
                    isIGPage={props.isIGPage}
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!isNoData && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("bar")} className={props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>

                            <span onClick={() => props.changeGraphType("pie")} className={props.graph_type === "pie" ? "active-chart" : ""}>
                                <Icon name="pie chart" />
                            </span>
                        </div>
                    )}
                    {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}

                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {props.isPublic && isNoData ? null : (
                        <MoreOptions
                            className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                            onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!isNoData && (
                            <>
                                {/* <CustomCheckBox
                                    label="Show Unique"
                                    checked={props.showUniqueLines}
                                    onClick={() => props.changeShowUniqueLine(!props.showUniqueLines)}
                                /> */}

                                <CustomCheckBox label="Show Legends" checked={props.showLegend} onClick={() => props.changeShowLegend(!props.showLegend)} />

                                {props.graph_type === "bar" && (
                                    <CustomCheckBox
                                        label="Show Grid Lines"
                                        checked={props.showGridLines}
                                        onClick={() => props.changeShowGridLines(!props.showGridLines)}
                                    />
                                )}
                                <CustomCheckBox label="Show Label" checked={props.showLabel} onClick={() => props.changeShowLabel(!props.showLabel)} />
                            </>
                        )}
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )}
            </div>
            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chart}>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    <div className="widget__tabs">
                        <div className={`unique_tab ${props.activeTab === 0 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(0)}>
                            Age Range
                        </div>
                        <div className={`unique_tab ${props.activeTab === 1 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(1)}>
                            Gender
                        </div>
                        <div className={`unique_tab ${props.activeTab === 2 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(2)}>
                            Country
                        </div>
                        <div className={`unique_tab ${props.activeTab === 3 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(3)}>
                            City
                        </div>
                    </div>
                    {props.activeTab === 0 && (
                        <AudienceByAge
                            setIsNoDataState={setIsNoDataState}
                            graph_type={props.graph_type}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            pageStatus={props.pageStatus}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {props.activeTab === 1 && (
                        <AudienceByGender
                            setIsNoDataState={setIsNoDataState}
                            graphType={props.graph_type}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                        />
                    )}
                    {props.activeTab === 2 && (
                        <AudienceByCountry
                            setIsNoDataState={setIsNoDataState}
                            graphType={props.graph_type}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                        />
                    )}
                    {props.activeTab === 3 && (
                        <AudienceByCity
                            setIsNoDataState={setIsNoDataState}
                            graphType={props.graph_type}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                        />
                    )}
                </div>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => increment()}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default AudienceMetrics;
